import { push } from "connected-react-router";

import { updateBlueprintId, initSetup, resetConstraints } from "containers/Setup/reducer";

import { resetSetup } from "containers/Setup/reducer";

export const UPDATE_FIELD = "createWizard/UPDATE_FIELD";
export const RESET = "createWizard/RESET";

const initialState = {
  isOpen: false,
  step: 0,
  jobId: undefined,
  enableButton: true,
  mode: 0,
  industry: undefined,
  function: undefined
};

function createWizardReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    case RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

/* Selectors */
export function getCreateWizard(state) {
  return state.createWizard;
}

export function getIsOpen(state) {
  return getCreateWizard(state).isOpen;
}

export function getStep(state) {
  return getCreateWizard(state).step;
}

export function getJobId(state) {
  return getCreateWizard(state).jobId;
}

export function getEnableButton(state) {
  return getCreateWizard(state).enableButton;
}

export function getIndustry(state) {
  return getCreateWizard(state).industry;
}

export function getFunction(state) {
  return getCreateWizard(state).function;
}

export function getLastRunId(state) {
  return getCreateWizard(state).lastRunId;
}

/* Actions */
export function updateIsOpen(isOpen, blueprintId) {
  return (dispatch, getState) => {
    if (isOpen === true) {
      dispatch(resetAll());
      dispatch(updateBlueprintId("new", blueprintId));
      dispatch(initSetup("new"));
    }
    return dispatch({ type: UPDATE_FIELD, data: isOpen, key: "isOpen" });
  };
}

export function updateStep(step) {
  return { type: UPDATE_FIELD, data: step, key: "step" };
}

export function updateStepDelta(stepDelta) {
  return (dispatch, getState) => {
    let step = getStep(getState()) + stepDelta;

    if (step < 0) {
      dispatch(push("/"));
      step = 0;
    }

    if (step === 3 && stepDelta === 1) {
      dispatch(resetConstraints("new"));
    }

    if (step > 4) {
      step = 4;
    }

    return dispatch({ type: UPDATE_FIELD, data: step, key: "step" });
  };
}

export function updateEnableButton(isEnabled) {
  return { type: UPDATE_FIELD, data: isEnabled, key: "enableButton" };
}

export function updateJobId(jobId) {
  return { type: UPDATE_FIELD, data: jobId, key: "jobId" };
}

export function updateIndustry(industry) {
  return { type: UPDATE_FIELD, data: industry, key: "industry" };
}

export function updateFunction(fun) {
  return { type: UPDATE_FIELD, data: fun, key: "function" };
}

export function updateLastRunId(lastRunId) {
  return { type: UPDATE_FIELD, data: lastRunId, key: "lastRunId" };
}

export function reset() {
  return { type: RESET };
}

export function resetWizard() {
  return (dispatch, getState) => {
    dispatch(resetSetup());
    return dispatch(reset());
  };
}

export function init(forceRefresh, blueprintId) {
  return (dispatch, getState) => {
    dispatch(initSetup("new", !forceRefresh));
  };
}

export default createWizardReducer;
